import { useEffect, useState } from "react";
import { useFetch } from "../../custom/api";
import "../../styles/Cards.css";
import TopNavbar2side from "../../components/TopNavbar2side";
import Card from "../../components/Card";
import GoToTop from "../../components/GoToTop";
import LoadingPage from "../../components/LoadingPage";
import EmptyComp from "../../components/EmptyComp";
import InfiniteScroll from "react-infinite-scroll-component";
import TopNavbarBack from "../../components/TopNavbarBack";

const Favorites = () => {
  const { myFetch } = useFetch();
  const [favorites, setFavorites] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPage] = useState(0);

  function refresh() {
    window.location.reload();
  }

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch(`favorites/get/${page}`, { method: "GET" });
      const r = await resp.json();

      if (favorites === null) {
        setFavorites(r.content);
      } else {
        setFavorites([...favorites, ...r.content]);
      }

      setTotalPage(r.total_pages);
    };
    fetchData();
  }, [page]);

  return (
    <>
      <TopNavbarBack
        title="‌‌علاقه‌مندی ها"
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["/cards"]}
        lbackground={["null"]}
      />
      {favorites === null ? (
        <LoadingPage />
      ) : Object.keys(favorites).length === 0 ? (
        <EmptyComp caption="به علاقه‌مندی‌ها چیزی اضافه نکردی؟"></EmptyComp>
      ) : (
        <InfiniteScroll
          dataLength={favorites.length} //This is important field to render the next data
          next={() => setPage(page + 1)}
          hasMore={page < totalPages}
          loader={<span className="loader"></span>}
          // endMessage={
          //   <p style={{ textAlign: "center" }}>
          //     <b>Yay! You have seen  it all</b>
          //   </p>
          // }
          // below props only if you need pull down functionality
          refreshFunction={refresh}
          pullDownToRefresh
          pullDownToRefreshThreshold={50}
          pullDownToRefreshContent={
            <h3 style={{ textAlign: "center" }}>
              &#8595; Pull down to refresh
            </h3>
          }
          releaseToRefreshContent={
            <h3 style={{ textAlign: "center" }}>&#8593; Release to refresh</h3>
          }
        >
          <div className="card-grid">
            {favorites.map((card) => {
              return <Card card={card} key={Math.random()} />;
            })}
          </div>
        </InfiniteScroll>
      )}

      <GoToTop />
    </>
  );
};

export default Favorites;
